/**
 * @file index.tsx
 *
 * @fileoverview Renders the search bar as a landing page row.
 */

import React from 'react';
import { SimpleSearchBarParagraph } from '~/jobiqo/types/types';
import { JobSearchForm } from '~/components/Form/SearchInputForm';
import { Box } from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';

export interface SimpleSearchBarProps {
  row: SimpleSearchBarParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const SimpleSearchBar = ({
  row,
  maxContainerSize,
}: SimpleSearchBarProps) => {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      margin={0}
      padding={0}
      backgroundColorOverride={
        row.background ? `var(--color-${row.background})` : 'transparent'
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <Spacing
          margin={0}
          paddingTop={row.spacing ?? 6}
          paddingBottom={row.spacing ?? 6}
        >
          <JobSearchForm />
        </Spacing>
      </Main>
    </Box>
  );
};
export default SimpleSearchBar;
